import React from 'react';
import styled from '@emotion/styled';
import { HelperText } from '../../form.styles';

interface MessageProps {
  text?: React.ReactNode;
  iconSize?: number;
  className?: string;
  id?: string;
  type: 'success' | 'error';
}

const Container = styled.div`
  display: flex;
`;

const Message: React.FC<MessageProps> = ({ type, text, iconSize = 12, className, id }) => (
  <Container className={className} id={id}>
    <HelperText className={className} state={type}>
      {text}
    </HelperText>
  </Container>
);

export default Message;
